export const DEFAULT_TEMPLATES_PAGESIZE = 8;
export const DEFAULT_CAMPAIGNS_PAGESIZE = 10;
export const DEFAULT_WHITELIST_URL = "https://www.venzapeak.com/support/public_resources/phishing/whitelist/#/";